const { createApp } = require("vue");
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.min.css";
// import createRouter from "./router/index";
import "bootstrap/dist/js/bootstrap.bundle";
import "mapbox-gl/dist/mapbox-gl.css";
import "bootstrap";
import axios from "axios";
import { createAuth } from "@websanova/vue-auth";
import driverHttpAxios from "@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js";
import driverRouterVueRouter from "@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js";
import Vuelidate from "vuelidate";
import PortalVue from "portal-vue";
import { createPinia } from "pinia";
import VueAuthBearer from "./bearer";
import endpoints from "./endpoints";
import router from "@/router/index";
import store from "@/store/index";
import AppImage from "@/components/AppImage.vue";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import BootstrapVue3 from "bootstrap-vue-3";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/styles/main.scss";
import { quillEditor } from "vue3-quill";
import "bootstrap";
import PageLoader from "@/components/PageLoader.vue"
import VueFeather from "vue-feather";
import FeatherWrapper from "@/components/feather/FeatherWrapper.vue";

// A ResizeObserver loop notification is usually benign, but it is also how a runaway
// resize feedback loop announces itself - the blank Recent Ancestry map reached
// production because this warning was being swallowed. Keep the webpack overlay out of
// the way while developing, but always surface the warning so the next one is visible.
const resizeObserverErrHandler = (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        console.warn('[ResizeObserver] loop detected - check for a resize feedback loop', e);
        if (process.env.NODE_ENV === 'development') {
            const overlay = document.getElementById('webpack-dev-server-client-overlay');
            if (overlay) overlay.remove();
            e.stopImmediatePropagation();
        }
    }
};
window.addEventListener('error', resizeObserverErrHandler);

// Create Vue app instance
const app = createApp(App);
// Use BootstrapVue3
app.use(BootstrapVue3);
app.use(quillEditor);

// Create Pinia store
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.component("Feather", VueFeather);
app.component("FeatherWrapper", FeatherWrapper);
app.component("PageLoader", PageLoader);
// Configure vue-auth
const auth = createAuth({
    plugins: {
        http: axios,
        router: router,
    },
    drivers: {
        http: driverHttpAxios,
        auth: VueAuthBearer,
        router: driverRouterVueRouter,
    },
    options: {
        rolesKey: "type",
        notFoundRedirect: { path: "/dashboard" },
        authRedirect: { path: "/signin" },
        loginData: {
            url: endpoints.loginApi,
            method: "POST",
            fetchUser: false,
            staySignedIn: true,
        },
        refreshData: {
            url: endpoints.refreshToken,
            method: "POST",
            enabled: true,
            interval: 30,
        },
        registerData: {
            url: endpoints.account,
            method: "POST",
            redirect: false,
        },
        fetchData: {
            url: endpoints.account,
            method: "GET",
            enabled: false,
        },
        stores: ["storage"],
        tokenDefaultName: "access_token",
        tokenStore: ["localStorage"],
    },
});

app.use(pinia);
app.component("AppImage", AppImage);

// Use plugins and components
app.use(store);
app.use(router);
app.use(Vuelidate);
app.use(PortalVue);
app.use(auth);
app.config.productionTip = false;

/* const LATEST_VERSION = "V2.16.17";
if (localStorage.getItem("LATEST_VERSION") !== LATEST_VERSION) {
    localStorage.setItem("LATEST_VERSION", LATEST_VERSION);
    window.location.reload(true);
} */

if (process.env.NODE_ENV === "production") {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-VH8BNC5BTY";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", "G-VH8BNC5BTY");
    };
}
app.mount("#app");